/**
 * Shared configuration values used across all environments.
 */
export const sharedConfig = {
	flags: {
		devTools: 'dev-tools',
		nexus: 'nexus-rights',
		newDDBEcuCompare: 'new-ddb-ecu-compare',
	},
	launchDarklyClientId: '664590c02c638010dc55095f',
};
